// extracted by mini-css-extract-plugin
export default {"no-data-cloud-invoice":"Edit_no-data-cloud-invoice__NjPJm","table-height-adjustment":"Edit_table-height-adjustment__Dcjmb"};